import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Svg from "../Svg";
import { SvgProps } from "../types";
import dummy from "../../../../assets/images/wavy-bg.svg";

const Icon: React.FC<SvgProps> = (props) => {
  let navigate = useNavigate();

  const [showSvg, setShowSvg] = useState(false);


  useEffect(() => {
    if (localStorage.getItem("label") === "meta-narrative") {
      if (props.data.length < 1) {
        setShowSvg(false);
      } else if (props.data.length > 0) {
        setShowSvg(true);
      }
    }
  }, [props.data]);

  return (
    <>
      {showSvg && (
        <Svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="704.168"
          height="2072.551"
          viewBox="0 0 704.168 2072.551"
          style={{ height: "auto" }}
        >
          <defs>
            <filter
              id="Path_337"
              x="298.584"
              y="112.378"
              width="84.237"
              height="64.756"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2"
              x="324.209"
              y="118.593"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-2" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-2" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-2"
              x="298.584"
              y="436.645"
              width="84.237"
              height="64.756"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-3" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-3" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-2"
              x="324.209"
              y="442.86"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-4" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-4" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-3"
              x="298.584"
              y="762.657"
              width="84.237"
              height="64.756"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-5" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-5" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-3"
              x="324.209"
              y="768.872"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-6" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-6" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-4"
              x="298.584"
              y="1087.47"
              width="84.237"
              height="64.756"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-7" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-7" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-4"
              x="324.209"
              y="1093.685"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-8" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-8" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-5"
              x="298.584"
              y="1737.003"
              width="84.237"
              height="64.756"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-9" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-9" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-5"
              x="324.209"
              y="1743.218"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-10" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-10" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-6"
              x="298.584"
              y="1412.282"
              width="84.237"
              height="64.756"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-11" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-11" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-6"
              x="324.209"
              y="1418.497"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-12" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-12" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-7"
              x="321.348"
              y="275.318"
              width="84.236"
              height="64.755"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-13" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-13" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-7"
              x="327.871"
              y="281.533"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-14" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-14" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-8"
              x="321.348"
              y="599.653"
              width="84.236"
              height="64.755"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-15" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-15" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-8"
              x="327.871"
              y="605.868"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-16" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-16" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-9"
              x="321.348"
              y="924.466"
              width="84.236"
              height="64.755"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-17" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-17" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-9"
              x="327.871"
              y="930.681"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-18" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-18" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-10"
              x="321.348"
              y="1249.279"
              width="84.236"
              height="64.755"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-19" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-19" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-10"
              x="327.871"
              y="1255.494"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-20" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-20" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-11"
              x="321.348"
              y="1899.944"
              width="84.236"
              height="64.755"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-21" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-21" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-11"
              x="327.871"
              y="1906.158"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-22" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-22" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Path_337-12"
              x="321.348"
              y="1575.236"
              width="84.236"
              height="64.755"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-23" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-23" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Ellipse_2-12"
              x="327.871"
              y="1581.451"
              width="52.088"
              height="52.088"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" result="blur-24" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-24" />
              <feComposite in="SourceGraphic" />
            </filter>
            <pattern
              id="pattern"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
            >
              <image
                width="310"
                height="310"
                xlinkHref="data:image/png;base64,"
              />
            </pattern>
            <pattern
              id="pattern1"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[0].url
                  }
                  style={{
                    opacity:
                      props.data[0]?.characters.length > 0
                        ? "1"
                        : props.data[0]?.story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern2"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 300 300"
              style={{ transform: "scaleX(-1)" }}
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="300"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[1].url
                  }
                  style={{
                    opacity:
                      props.data[1].characters.length > 0
                        ? "1"
                        : props.data[1].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern3"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[2].url
                  }
                  style={{
                    opacity:
                      props.data[2].characters.length > 0
                        ? "1"
                        : props.data[2].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern4"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
              style={{ transform: "scaleX(-1)" }}
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[3].url
                  }
                  style={{
                    opacity:
                      props.data[3].characters.length > 0
                        ? "1"
                        : props.data[3].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern5"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[4].url
                  }
                  style={{
                    opacity:
                      props.data[4].characters.length > 0
                        ? "1"
                        : props.data[4].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern6"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
              style={{ transform: "scaleX(-1)" }}
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[5].url
                  }
                  style={{
                    opacity:
                      props.data[5].characters.length > 0
                        ? "1"
                        : props.data[5].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern7"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[6].url
                  }
                  style={{
                    opacity:
                      props.data[6].characters.length > 0
                        ? "1"
                        : props.data[6].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern8"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
              style={{ transform: "scaleX(-1)" }}
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[7].url
                  }
                  style={{
                    opacity:
                      props.data[7].characters.length > 0
                        ? "1"
                        : props.data[7].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern9"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[8].url
                  }
                  style={{
                    opacity:
                      props.data[8].characters.length > 0
                        ? "1"
                        : props.data[8].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern10"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
              style={{ transform: "scaleX(-1)" }}
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[9].url
                  }
                  style={{
                    opacity:
                      props.data[9].characters.length > 0
                        ? "1"
                        : props.data[9].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern11"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[10].url
                  }
                  style={{
                    opacity:
                      props.data[10].characters.length > 0
                        ? "1"
                        : props.data[10].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>
            <pattern
              id="pattern12"
              preserveAspectRatio="xMinYMid slice"
              width="100%"
              height="100%"
              viewBox="0 0 310 310"
              style={{ transform: "scaleX(-1)" }}
            >
              {props.data.length > 1 ? (
                <image
                  width="310"
                  height="310"
                  xlinkHref={
                    "https://app.deafpathwaybible.com/storage/icons/thumb/" +
                    props.data[11].url
                  }
                  style={{
                    opacity:
                      props.data[11].characters.length > 0
                        ? "1"
                        : props.data[11].story_sets.length > 0
                        ? "1"
                        : "0.5",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <image width="100" height="183" xlinkHref={dummy} />
              )}
            </pattern>

            <pattern
              id="pattern-7"
              width="1"
              height="1"
              patternTransform="matrix(1, 0, 0, -1, 0, 498.085)"
              viewBox="0 0 225 249.043"
            >
              {/* <use preserveAspectRatio="none" xlinkHref="#image" /> */}
            </pattern>
          </defs>
          <g
            id="Group_268"
            data-name="Group 268"
            transform="translate(-1551.498 -63.783)"
          >
            <g
              id="Group_267"
              data-name="Group 267"
              transform="translate(456.498 -340.5)"
            >
              <g
                id="Timeline"
                transform="translate(1491.584 522.079) rotate(90)"
              >
                <line
                  id="Line_2"
                  data-name="Line 2"
                  x2="1800.468"
                  transform="translate(24.341 43.554)"
                  fill="none"
                  stroke="#67bb4f"
                  stroke-width="6"
                />
                <g
                  id="Point_Up"
                  data-name="Point Up"
                  transform="translate(0.582 22.762)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -118.38, 373.82)"
                    filter="url(#Path_337)"
                  >
                    <g
                      id="Path_337-13"
                      data-name="Path 337"
                      transform="translate(373.82 118.38) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.3779125213623 65.53894805908203 C 22.05785179138184 64.02519989013672 16.75339126586914 57.04958343505859 11.59962272644043 48.87775802612305 C 2.425682544708252 34.33153915405273 0.5000025033950806 26.98199844360352 0.5000025033950806 23.37794876098633 C 0.5000025033950806 20.28922843933105 1.104822516441345 17.29315757751465 2.29765248298645 14.47296810150146 C 3.449912548065186 11.74873828887939 5.099562644958496 9.302028656005859 7.20079231262207 7.200798034667969 C 9.302022933959961 5.099568367004395 11.74872207641602 3.449908256530762 14.4729528427124 2.297658205032349 C 17.29313278198242 1.104818224906921 20.28919219970703 0.4999982118606567 23.3779125213623 0.4999982118606567 C 26.46663284301758 0.4999982118606567 29.46269226074219 1.104818224906921 32.28287124633789 2.297658205032349 C 35.00710296630859 3.449908256530762 37.45381164550781 5.099568367004395 39.5550422668457 7.200798034667969 C 41.65627288818359 9.302028656005859 43.30592346191406 11.74873828887939 44.45817184448242 14.47296810150146 C 45.6510009765625 17.29315757751465 46.25582122802734 20.28922843933105 46.25582122802734 23.37794876098633 C 46.25582122802734 26.98199844360352 44.33014297485352 34.33153915405273 35.15619277954102 48.87775802612305 C 30.00243377685547 57.0495719909668 24.69797325134277 64.02519989013672 23.3779125213623 65.53894805908203 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.3779125213623 64.76595306396484 C 25.11850357055664 62.64865875244141 30.01641273498535 56.10863494873047 34.8416633605957 48.43896865844727 C 38.04163360595703 43.35266876220703 40.59296417236328 38.7511100769043 42.42477416992188 34.76211929321289 C 44.63509368896484 29.9488582611084 45.75582122802734 26.11867904663086 45.75582122802734 23.37794876098633 C 45.75582122802734 20.35650825500488 45.16429138183594 17.42596817016602 43.99766159057617 14.66774845123291 C 42.87062072753906 12.00311851501465 41.25695419311523 9.609827995300293 39.20148086547852 7.554347991943359 C 37.14601135253906 5.498878002166748 34.75272369384766 3.88519811630249 32.08810424804688 2.758158206939697 C 29.32988166809082 1.591528177261353 26.39935302734375 0.9999982118606567 23.3779125213623 0.9999982118606567 C 20.35647201538086 0.9999982118606567 17.42594337463379 1.591528177261353 14.66773223876953 2.758158206939697 C 12.00310230255127 3.88519811630249 9.60981273651123 5.498878002166748 7.554342746734619 7.554347991943359 C 5.498872756958008 9.609827995300293 3.885202407836914 12.00311851501465 2.758162498474121 14.66774845123291 C 1.591532468795776 17.42596817016602 1.000002503395081 20.35650825500488 1.000002503395081 23.37794876098633 C 1.000002503395081 26.11867904663086 2.120732545852661 29.9488582611084 4.331052303314209 34.76210784912109 C 6.162862300872803 38.7511100769043 8.71418285369873 43.35265731811523 11.91415214538574 48.43896865844727 C 16.73941040039062 56.108642578125 21.63731956481934 62.64866256713867 23.3779125213623 64.76595306396484 M 23.3779125213623 66.23681640625 C 22.86361312866211 66.23681640625 2.521362375773606e-06 36.28923797607422 2.521362375773606e-06 23.37794876098633 C 2.521362375773606e-06 10.46666812896729 10.46665287017822 -1.796875039872248e-06 23.3779125213623 -1.796875039872248e-06 C 36.28918075561523 -1.796875039872248e-06 46.75582122802734 10.46666812896729 46.75582122802734 23.37794876098633 C 46.75582122802734 36.28923797607422 23.89220237731934 66.23681640625 23.3779125213623 66.23681640625 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -118.38, 373.82)"
                    filter="url(#Ellipse_2)"
                  >
                    <g
                      id="Ellipse_2-13"
                      data-name="Ellipse 2"
                      transform="translate(367.3 124.59) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-2"
                  data-name="Point Up"
                  transform="translate(324.85 22.762)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -442.65, 373.82)"
                    filter="url(#Path_337-2)"
                  >
                    <g
                      id="Path_337-14"
                      data-name="Path 337"
                      transform="translate(373.82 442.65) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.3779125213623 65.53894805908203 C 22.05785179138184 64.02519989013672 16.75339126586914 57.04958343505859 11.59962272644043 48.87775802612305 C 2.425682544708252 34.33153915405273 0.5000025033950806 26.98199844360352 0.5000025033950806 23.37794876098633 C 0.5000025033950806 20.28922843933105 1.104822516441345 17.29315757751465 2.29765248298645 14.47296810150146 C 3.449912548065186 11.74873828887939 5.099562644958496 9.302028656005859 7.20079231262207 7.200798034667969 C 9.302022933959961 5.099568367004395 11.74872207641602 3.449908256530762 14.4729528427124 2.297658205032349 C 17.29313278198242 1.104818224906921 20.28919219970703 0.4999982118606567 23.3779125213623 0.4999982118606567 C 26.46663284301758 0.4999982118606567 29.46269226074219 1.104818224906921 32.28287124633789 2.297658205032349 C 35.00710296630859 3.449908256530762 37.45381164550781 5.099568367004395 39.5550422668457 7.200798034667969 C 41.65627288818359 9.302028656005859 43.30592346191406 11.74873828887939 44.45817184448242 14.47296810150146 C 45.6510009765625 17.29315757751465 46.25582122802734 20.28922843933105 46.25582122802734 23.37794876098633 C 46.25582122802734 26.98199844360352 44.33014297485352 34.33153915405273 35.15619277954102 48.87775802612305 C 30.00243377685547 57.0495719909668 24.69797325134277 64.02519989013672 23.3779125213623 65.53894805908203 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.3779125213623 64.76595306396484 C 25.11850357055664 62.64865875244141 30.01641273498535 56.10863494873047 34.8416633605957 48.43896865844727 C 38.04163360595703 43.35266876220703 40.59296417236328 38.7511100769043 42.42477416992188 34.76211929321289 C 44.63509368896484 29.9488582611084 45.75582122802734 26.11867904663086 45.75582122802734 23.37794876098633 C 45.75582122802734 20.35650825500488 45.16429138183594 17.42596817016602 43.99766159057617 14.66774845123291 C 42.87062072753906 12.00311851501465 41.25695419311523 9.609827995300293 39.20148086547852 7.554347991943359 C 37.14601135253906 5.498878002166748 34.75272369384766 3.88519811630249 32.08810424804688 2.758158206939697 C 29.32988166809082 1.591528177261353 26.39935302734375 0.9999982118606567 23.3779125213623 0.9999982118606567 C 20.35647201538086 0.9999982118606567 17.42594337463379 1.591528177261353 14.66773223876953 2.758158206939697 C 12.00310230255127 3.88519811630249 9.60981273651123 5.498878002166748 7.554342746734619 7.554347991943359 C 5.498872756958008 9.609827995300293 3.885202407836914 12.00311851501465 2.758162498474121 14.66774845123291 C 1.591532468795776 17.42596817016602 1.000002503395081 20.35650825500488 1.000002503395081 23.37794876098633 C 1.000002503395081 26.11867904663086 2.120732545852661 29.9488582611084 4.331052303314209 34.76210784912109 C 6.162862300872803 38.7511100769043 8.71418285369873 43.35265731811523 11.91415214538574 48.43896865844727 C 16.73941040039062 56.108642578125 21.63731956481934 62.64866256713867 23.3779125213623 64.76595306396484 M 23.3779125213623 66.23681640625 C 22.86361312866211 66.23681640625 2.521362375773606e-06 36.28923797607422 2.521362375773606e-06 23.37794876098633 C 2.521362375773606e-06 10.46666812896729 10.46665287017822 -1.796875039872248e-06 23.3779125213623 -1.796875039872248e-06 C 36.28918075561523 -1.796875039872248e-06 46.75582122802734 10.46666812896729 46.75582122802734 23.37794876098633 C 46.75582122802734 36.28923797607422 23.89220237731934 66.23681640625 23.3779125213623 66.23681640625 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -442.65, 373.82)"
                    filter="url(#Ellipse_2-2)"
                  >
                    <g
                      id="Ellipse_2-14"
                      data-name="Ellipse 2"
                      transform="translate(367.3 448.86) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-3"
                  data-name="Point Up"
                  transform="translate(650.861 22.762)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -768.66, 373.82)"
                    filter="url(#Path_337-3)"
                  >
                    <g
                      id="Path_337-15"
                      data-name="Path 337"
                      transform="translate(373.82 768.66) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.3779125213623 65.53894805908203 C 22.05785179138184 64.02519989013672 16.75339126586914 57.04958343505859 11.59962272644043 48.87775802612305 C 2.425682544708252 34.33153915405273 0.5000025033950806 26.98199844360352 0.5000025033950806 23.37794876098633 C 0.5000025033950806 20.28922843933105 1.104822516441345 17.29315757751465 2.29765248298645 14.47296810150146 C 3.449912548065186 11.74873828887939 5.099562644958496 9.302028656005859 7.20079231262207 7.200798034667969 C 9.302022933959961 5.099568367004395 11.74872207641602 3.449908256530762 14.4729528427124 2.297658205032349 C 17.29313278198242 1.104818224906921 20.28919219970703 0.4999982118606567 23.3779125213623 0.4999982118606567 C 26.46663284301758 0.4999982118606567 29.46269226074219 1.104818224906921 32.28287124633789 2.297658205032349 C 35.00710296630859 3.449908256530762 37.45381164550781 5.099568367004395 39.5550422668457 7.200798034667969 C 41.65627288818359 9.302028656005859 43.30592346191406 11.74873828887939 44.45817184448242 14.47296810150146 C 45.6510009765625 17.29315757751465 46.25582122802734 20.28922843933105 46.25582122802734 23.37794876098633 C 46.25582122802734 26.98199844360352 44.33014297485352 34.33153915405273 35.15619277954102 48.87775802612305 C 30.00243377685547 57.0495719909668 24.69797325134277 64.02519989013672 23.3779125213623 65.53894805908203 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.3779125213623 64.76595306396484 C 25.11850357055664 62.64865875244141 30.01641273498535 56.10863494873047 34.8416633605957 48.43896865844727 C 38.04163360595703 43.35266876220703 40.59296417236328 38.7511100769043 42.42477416992188 34.76211929321289 C 44.63509368896484 29.9488582611084 45.75582122802734 26.11867904663086 45.75582122802734 23.37794876098633 C 45.75582122802734 20.35650825500488 45.16429138183594 17.42596817016602 43.99766159057617 14.66774845123291 C 42.87062072753906 12.00311851501465 41.25695419311523 9.609827995300293 39.20148086547852 7.554347991943359 C 37.14601135253906 5.498878002166748 34.75272369384766 3.88519811630249 32.08810424804688 2.758158206939697 C 29.32988166809082 1.591528177261353 26.39935302734375 0.9999982118606567 23.3779125213623 0.9999982118606567 C 20.35647201538086 0.9999982118606567 17.42594337463379 1.591528177261353 14.66773223876953 2.758158206939697 C 12.00310230255127 3.88519811630249 9.60981273651123 5.498878002166748 7.554342746734619 7.554347991943359 C 5.498872756958008 9.609827995300293 3.885202407836914 12.00311851501465 2.758162498474121 14.66774845123291 C 1.591532468795776 17.42596817016602 1.000002503395081 20.35650825500488 1.000002503395081 23.37794876098633 C 1.000002503395081 26.11867904663086 2.120732545852661 29.9488582611084 4.331052303314209 34.76210784912109 C 6.162862300872803 38.7511100769043 8.71418285369873 43.35265731811523 11.91415214538574 48.43896865844727 C 16.73941040039062 56.108642578125 21.63731956481934 62.64866256713867 23.3779125213623 64.76595306396484 M 23.3779125213623 66.23681640625 C 22.86361312866211 66.23681640625 2.521362375773606e-06 36.28923797607422 2.521362375773606e-06 23.37794876098633 C 2.521362375773606e-06 10.46666812896729 10.46665287017822 -1.796875039872248e-06 23.3779125213623 -1.796875039872248e-06 C 36.28918075561523 -1.796875039872248e-06 46.75582122802734 10.46666812896729 46.75582122802734 23.37794876098633 C 46.75582122802734 36.28923797607422 23.89220237731934 66.23681640625 23.3779125213623 66.23681640625 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -768.66, 373.82)"
                    filter="url(#Ellipse_2-3)"
                  >
                    <g
                      id="Ellipse_2-15"
                      data-name="Ellipse 2"
                      transform="translate(367.3 774.87) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-4"
                  data-name="Point Up"
                  transform="translate(975.674 22.762)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -1093.47, 373.82)"
                    filter="url(#Path_337-4)"
                  >
                    <g
                      id="Path_337-16"
                      data-name="Path 337"
                      transform="translate(373.82 1093.47) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.3779125213623 65.53894805908203 C 22.05785179138184 64.02519989013672 16.75339126586914 57.04958343505859 11.59962272644043 48.87775802612305 C 2.425682544708252 34.33153915405273 0.5000025033950806 26.98199844360352 0.5000025033950806 23.37794876098633 C 0.5000025033950806 20.28922843933105 1.104822516441345 17.29315757751465 2.29765248298645 14.47296810150146 C 3.449912548065186 11.74873828887939 5.099562644958496 9.302028656005859 7.20079231262207 7.200798034667969 C 9.302022933959961 5.099568367004395 11.74872207641602 3.449908256530762 14.4729528427124 2.297658205032349 C 17.29313278198242 1.104818224906921 20.28919219970703 0.4999982118606567 23.3779125213623 0.4999982118606567 C 26.46663284301758 0.4999982118606567 29.46269226074219 1.104818224906921 32.28287124633789 2.297658205032349 C 35.00710296630859 3.449908256530762 37.45381164550781 5.099568367004395 39.5550422668457 7.200798034667969 C 41.65627288818359 9.302028656005859 43.30592346191406 11.74873828887939 44.45817184448242 14.47296810150146 C 45.6510009765625 17.29315757751465 46.25582122802734 20.28922843933105 46.25582122802734 23.37794876098633 C 46.25582122802734 26.98199844360352 44.33014297485352 34.33153915405273 35.15619277954102 48.87775802612305 C 30.00243377685547 57.0495719909668 24.69797325134277 64.02519989013672 23.3779125213623 65.53894805908203 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.3779125213623 64.76595306396484 C 25.11850357055664 62.64865875244141 30.01641273498535 56.10863494873047 34.8416633605957 48.43896865844727 C 38.04163360595703 43.35266876220703 40.59296417236328 38.7511100769043 42.42477416992188 34.76211929321289 C 44.63509368896484 29.9488582611084 45.75582122802734 26.11867904663086 45.75582122802734 23.37794876098633 C 45.75582122802734 20.35650825500488 45.16429138183594 17.42596817016602 43.99766159057617 14.66774845123291 C 42.87062072753906 12.00311851501465 41.25695419311523 9.609827995300293 39.20148086547852 7.554347991943359 C 37.14601135253906 5.498878002166748 34.75272369384766 3.88519811630249 32.08810424804688 2.758158206939697 C 29.32988166809082 1.591528177261353 26.39935302734375 0.9999982118606567 23.3779125213623 0.9999982118606567 C 20.35647201538086 0.9999982118606567 17.42594337463379 1.591528177261353 14.66773223876953 2.758158206939697 C 12.00310230255127 3.88519811630249 9.60981273651123 5.498878002166748 7.554342746734619 7.554347991943359 C 5.498872756958008 9.609827995300293 3.885202407836914 12.00311851501465 2.758162498474121 14.66774845123291 C 1.591532468795776 17.42596817016602 1.000002503395081 20.35650825500488 1.000002503395081 23.37794876098633 C 1.000002503395081 26.11867904663086 2.120732545852661 29.9488582611084 4.331052303314209 34.76210784912109 C 6.162862300872803 38.7511100769043 8.71418285369873 43.35265731811523 11.91415214538574 48.43896865844727 C 16.73941040039062 56.108642578125 21.63731956481934 62.64866256713867 23.3779125213623 64.76595306396484 M 23.3779125213623 66.23681640625 C 22.86361312866211 66.23681640625 2.521362375773606e-06 36.28923797607422 2.521362375773606e-06 23.37794876098633 C 2.521362375773606e-06 10.46666812896729 10.46665287017822 -1.796875039872248e-06 23.3779125213623 -1.796875039872248e-06 C 36.28918075561523 -1.796875039872248e-06 46.75582122802734 10.46666812896729 46.75582122802734 23.37794876098633 C 46.75582122802734 36.28923797607422 23.89220237731934 66.23681640625 23.3779125213623 66.23681640625 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -1093.47, 373.82)"
                    filter="url(#Ellipse_2-4)"
                  >
                    <g
                      id="Ellipse_2-16"
                      data-name="Ellipse 2"
                      transform="translate(367.3 1099.68) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-5"
                  data-name="Point Up"
                  transform="translate(1625.208 22.762)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -1743, 373.82)"
                    filter="url(#Path_337-5)"
                  >
                    <g
                      id="Path_337-17"
                      data-name="Path 337"
                      transform="translate(373.82 1743) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.3779125213623 65.53894805908203 C 22.05785179138184 64.02519989013672 16.75339126586914 57.04958343505859 11.59962272644043 48.87775802612305 C 2.425682544708252 34.33153915405273 0.5000025033950806 26.98199844360352 0.5000025033950806 23.37794876098633 C 0.5000025033950806 20.28922843933105 1.104822516441345 17.29315757751465 2.29765248298645 14.47296810150146 C 3.449912548065186 11.74873828887939 5.099562644958496 9.302028656005859 7.20079231262207 7.200798034667969 C 9.302022933959961 5.099568367004395 11.74872207641602 3.449908256530762 14.4729528427124 2.297658205032349 C 17.29313278198242 1.104818224906921 20.28919219970703 0.4999982118606567 23.3779125213623 0.4999982118606567 C 26.46663284301758 0.4999982118606567 29.46269226074219 1.104818224906921 32.28287124633789 2.297658205032349 C 35.00710296630859 3.449908256530762 37.45381164550781 5.099568367004395 39.5550422668457 7.200798034667969 C 41.65627288818359 9.302028656005859 43.30592346191406 11.74873828887939 44.45817184448242 14.47296810150146 C 45.6510009765625 17.29315757751465 46.25582122802734 20.28922843933105 46.25582122802734 23.37794876098633 C 46.25582122802734 26.98199844360352 44.33014297485352 34.33153915405273 35.15619277954102 48.87775802612305 C 30.00243377685547 57.0495719909668 24.69797325134277 64.02519989013672 23.3779125213623 65.53894805908203 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.3779125213623 64.76595306396484 C 25.11850357055664 62.64865875244141 30.01641273498535 56.10863494873047 34.8416633605957 48.43896865844727 C 38.04163360595703 43.35266876220703 40.59296417236328 38.7511100769043 42.42477416992188 34.76211929321289 C 44.63509368896484 29.9488582611084 45.75582122802734 26.11867904663086 45.75582122802734 23.37794876098633 C 45.75582122802734 20.35650825500488 45.16429138183594 17.42596817016602 43.99766159057617 14.66774845123291 C 42.87062072753906 12.00311851501465 41.25695419311523 9.609827995300293 39.20148086547852 7.554347991943359 C 37.14601135253906 5.498878002166748 34.75272369384766 3.88519811630249 32.08810424804688 2.758158206939697 C 29.32988166809082 1.591528177261353 26.39935302734375 0.9999982118606567 23.3779125213623 0.9999982118606567 C 20.35647201538086 0.9999982118606567 17.42594337463379 1.591528177261353 14.66773223876953 2.758158206939697 C 12.00310230255127 3.88519811630249 9.60981273651123 5.498878002166748 7.554342746734619 7.554347991943359 C 5.498872756958008 9.609827995300293 3.885202407836914 12.00311851501465 2.758162498474121 14.66774845123291 C 1.591532468795776 17.42596817016602 1.000002503395081 20.35650825500488 1.000002503395081 23.37794876098633 C 1.000002503395081 26.11867904663086 2.120732545852661 29.9488582611084 4.331052303314209 34.76210784912109 C 6.162862300872803 38.7511100769043 8.71418285369873 43.35265731811523 11.91415214538574 48.43896865844727 C 16.73941040039062 56.108642578125 21.63731956481934 62.64866256713867 23.3779125213623 64.76595306396484 M 23.3779125213623 66.23681640625 C 22.86361312866211 66.23681640625 2.521362375773606e-06 36.28923797607422 2.521362375773606e-06 23.37794876098633 C 2.521362375773606e-06 10.46666812896729 10.46665287017822 -1.796875039872248e-06 23.3779125213623 -1.796875039872248e-06 C 36.28918075561523 -1.796875039872248e-06 46.75582122802734 10.46666812896729 46.75582122802734 23.37794876098633 C 46.75582122802734 36.28923797607422 23.89220237731934 66.23681640625 23.3779125213623 66.23681640625 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -1743, 373.82)"
                    filter="url(#Ellipse_2-5)"
                  >
                    <g
                      id="Ellipse_2-17"
                      data-name="Ellipse 2"
                      transform="translate(367.3 1749.22) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-6"
                  data-name="Point Up"
                  transform="translate(1300.487 22.762)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -1418.28, 373.82)"
                    filter="url(#Path_337-6)"
                  >
                    <g
                      id="Path_337-18"
                      data-name="Path 337"
                      transform="translate(373.82 1418.28) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.3779125213623 65.53894805908203 C 22.05785179138184 64.02519989013672 16.75339126586914 57.04958343505859 11.59962272644043 48.87775802612305 C 2.425682544708252 34.33153915405273 0.5000025033950806 26.98199844360352 0.5000025033950806 23.37794876098633 C 0.5000025033950806 20.28922843933105 1.104822516441345 17.29315757751465 2.29765248298645 14.47296810150146 C 3.449912548065186 11.74873828887939 5.099562644958496 9.302028656005859 7.20079231262207 7.200798034667969 C 9.302022933959961 5.099568367004395 11.74872207641602 3.449908256530762 14.4729528427124 2.297658205032349 C 17.29313278198242 1.104818224906921 20.28919219970703 0.4999982118606567 23.3779125213623 0.4999982118606567 C 26.46663284301758 0.4999982118606567 29.46269226074219 1.104818224906921 32.28287124633789 2.297658205032349 C 35.00710296630859 3.449908256530762 37.45381164550781 5.099568367004395 39.5550422668457 7.200798034667969 C 41.65627288818359 9.302028656005859 43.30592346191406 11.74873828887939 44.45817184448242 14.47296810150146 C 45.6510009765625 17.29315757751465 46.25582122802734 20.28922843933105 46.25582122802734 23.37794876098633 C 46.25582122802734 26.98199844360352 44.33014297485352 34.33153915405273 35.15619277954102 48.87775802612305 C 30.00243377685547 57.0495719909668 24.69797325134277 64.02519989013672 23.3779125213623 65.53894805908203 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.3779125213623 64.76595306396484 C 25.11850357055664 62.64865875244141 30.01641273498535 56.10863494873047 34.8416633605957 48.43896865844727 C 38.04163360595703 43.35266876220703 40.59296417236328 38.7511100769043 42.42477416992188 34.76211929321289 C 44.63509368896484 29.9488582611084 45.75582122802734 26.11867904663086 45.75582122802734 23.37794876098633 C 45.75582122802734 20.35650825500488 45.16429138183594 17.42596817016602 43.99766159057617 14.66774845123291 C 42.87062072753906 12.00311851501465 41.25695419311523 9.609827995300293 39.20148086547852 7.554347991943359 C 37.14601135253906 5.498878002166748 34.75272369384766 3.88519811630249 32.08810424804688 2.758158206939697 C 29.32988166809082 1.591528177261353 26.39935302734375 0.9999982118606567 23.3779125213623 0.9999982118606567 C 20.35647201538086 0.9999982118606567 17.42594337463379 1.591528177261353 14.66773223876953 2.758158206939697 C 12.00310230255127 3.88519811630249 9.60981273651123 5.498878002166748 7.554342746734619 7.554347991943359 C 5.498872756958008 9.609827995300293 3.885202407836914 12.00311851501465 2.758162498474121 14.66774845123291 C 1.591532468795776 17.42596817016602 1.000002503395081 20.35650825500488 1.000002503395081 23.37794876098633 C 1.000002503395081 26.11867904663086 2.120732545852661 29.9488582611084 4.331052303314209 34.76210784912109 C 6.162862300872803 38.7511100769043 8.71418285369873 43.35265731811523 11.91415214538574 48.43896865844727 C 16.73941040039062 56.108642578125 21.63731956481934 62.64866256713867 23.3779125213623 64.76595306396484 M 23.3779125213623 66.23681640625 C 22.86361312866211 66.23681640625 2.521362375773606e-06 36.28923797607422 2.521362375773606e-06 23.37794876098633 C 2.521362375773606e-06 10.46666812896729 10.46665287017822 -1.796875039872248e-06 23.3779125213623 -1.796875039872248e-06 C 36.28918075561523 -1.796875039872248e-06 46.75582122802734 10.46666812896729 46.75582122802734 23.37794876098633 C 46.75582122802734 36.28923797607422 23.89220237731934 66.23681640625 23.3779125213623 66.23681640625 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -1418.28, 373.82)"
                    filter="url(#Ellipse_2-6)"
                  >
                    <g
                      id="Ellipse_2-18"
                      data-name="Ellipse 2"
                      transform="translate(367.3 1424.5) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-7"
                  data-name="Point Up"
                  transform="translate(163.523 0)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -281.32, 396.58)"
                    filter="url(#Path_337-7)"
                  >
                    <g
                      id="Path_337-19"
                      data-name="Path 337"
                      transform="translate(396.58 281.32) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.37764739990234 65.73581695556641 C 20.28896713256836 65.73581695556641 17.29293823242188 65.13100433349609 14.47278785705566 63.93818283081055 C 11.7485876083374 62.78594589233398 9.301907539367676 61.13632583618164 7.20070743560791 59.03511428833008 C 5.099497318267822 56.93391418457031 3.449867486953735 54.48724365234375 2.297627449035645 51.76305389404297 C 1.104807376861572 48.94291305541992 0.4999974071979523 45.94689559936523 0.4999974071979523 42.85821533203125 C 0.4999974071979523 39.25422286987305 2.425657510757446 31.90479469299316 11.59949779510498 17.35880470275879 C 16.75320243835449 9.187118530273438 22.05760383605957 2.211601257324219 23.37764739990234 0.6978706121444702 C 24.69769096374512 2.211601257324219 30.0020923614502 9.187118530273438 35.15579605102539 17.35880470275879 C 44.32963562011719 31.90479469299316 46.25529861450195 39.25422286987305 46.25529861450195 42.85821533203125 C 46.25529861450195 45.94689559936523 45.65048599243164 48.94291305541992 44.45766830444336 51.76305389404297 C 43.30542755126953 54.48724365234375 41.65579605102539 56.93391418457031 39.55458831787109 59.03511428833008 C 37.45338821411133 61.13632583618164 35.00670623779297 62.78594589233398 32.28250885009766 63.93818283081055 C 29.46235656738281 65.13100433349609 26.46632766723633 65.73581695556641 23.37764739990234 65.73581695556641 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.37764739990234 1.470855712890625 C 21.63707542419434 3.588119506835938 16.73922538757324 10.12803649902344 11.91402816772461 17.79758453369141 C 8.714096069335938 22.88381576538086 6.162796020507812 27.48530578613281 4.331008911132812 31.47423553466797 C 2.120708465576172 36.28740692138672 0.9999961853027344 40.11753463745117 0.9999961853027344 42.85821533203125 C 0.9999961853027344 45.87960433959961 1.591518402099609 48.81009674072266 2.758136749267578 51.56827545166016 C 3.885158538818359 54.23286437988281 5.498805999755859 56.62611389160156 7.554256439208984 58.68155670166016 C 9.609706878662109 60.73699569702148 12.00296783447266 62.35064315795898 14.66755676269531 63.47767639160156 C 17.42574691772461 64.644287109375 20.35624694824219 65.23580169677734 23.37764739990234 65.23580169677734 C 26.3990478515625 65.23580169677734 29.32954788208008 64.644287109375 32.08773803710938 63.47767639160156 C 34.75232696533203 62.35064315795898 37.14558792114258 60.73699569702148 39.2010383605957 58.68155670166016 C 41.25648880004883 56.62611389160156 42.87013626098633 54.23286437988281 43.99715805053711 51.56827545166016 C 45.16377639770508 48.81009674072266 45.75529861450195 45.87960433959961 45.75529861450195 42.85821533203125 C 45.75529861450195 40.11753463745117 44.63458633422852 36.28740692138672 42.42428588867188 31.47423553466797 C 40.59249877929688 27.48530578613281 38.04119873046875 22.88381576538086 34.84126663208008 17.79758453369141 C 30.01606941223145 10.12803649902344 25.11821937561035 3.588119506835938 23.37764739990234 1.470855712890625 M 23.37764739990234 -7.62939453125e-06 C 23.89193725585938 -7.62939453125e-06 46.75529861450195 29.94712448120117 46.75529861450195 42.85821533203125 C 46.75529861450195 55.76929473876953 36.28876876831055 66.23580169677734 23.37764739990234 66.23580169677734 C 10.46652603149414 66.23580169677734 -3.814697265625e-06 55.76929473876953 -3.814697265625e-06 42.85821533203125 C -3.814697265625e-06 29.94712448120117 22.86335754394531 -7.62939453125e-06 23.37764739990234 -7.62939453125e-06 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -281.32, 396.58)"
                    filter="url(#Ellipse_2-7)"
                  >
                    <g
                      id="Ellipse_2-19"
                      data-name="Ellipse 2"
                      transform="translate(370.96 287.53) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-8"
                  data-name="Point Up"
                  transform="translate(487.858 0)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -605.65, 396.58)"
                    filter="url(#Path_337-8)"
                  >
                    <g
                      id="Path_337-20"
                      data-name="Path 337"
                      transform="translate(396.58 605.65) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.37764739990234 65.73581695556641 C 20.28896713256836 65.73581695556641 17.29293823242188 65.13100433349609 14.47278785705566 63.93818283081055 C 11.7485876083374 62.78594589233398 9.301907539367676 61.13632583618164 7.20070743560791 59.03511428833008 C 5.099497318267822 56.93391418457031 3.449867486953735 54.48724365234375 2.297627449035645 51.76305389404297 C 1.104807376861572 48.94291305541992 0.4999974071979523 45.94689559936523 0.4999974071979523 42.85821533203125 C 0.4999974071979523 39.25422286987305 2.425657510757446 31.90479469299316 11.59949779510498 17.35880470275879 C 16.75320243835449 9.187118530273438 22.05760383605957 2.211601257324219 23.37764739990234 0.6978706121444702 C 24.69769096374512 2.211601257324219 30.0020923614502 9.187118530273438 35.15579605102539 17.35880470275879 C 44.32963562011719 31.90479469299316 46.25529861450195 39.25422286987305 46.25529861450195 42.85821533203125 C 46.25529861450195 45.94689559936523 45.65048599243164 48.94291305541992 44.45766830444336 51.76305389404297 C 43.30542755126953 54.48724365234375 41.65579605102539 56.93391418457031 39.55458831787109 59.03511428833008 C 37.45338821411133 61.13632583618164 35.00670623779297 62.78594589233398 32.28250885009766 63.93818283081055 C 29.46235656738281 65.13100433349609 26.46632766723633 65.73581695556641 23.37764739990234 65.73581695556641 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.37764739990234 1.470855712890625 C 21.63707542419434 3.588119506835938 16.73922538757324 10.12803649902344 11.91402816772461 17.79758453369141 C 8.714096069335938 22.88381576538086 6.162796020507812 27.48530578613281 4.331008911132812 31.47423553466797 C 2.120708465576172 36.28740692138672 0.9999961853027344 40.11753463745117 0.9999961853027344 42.85821533203125 C 0.9999961853027344 45.87960433959961 1.591518402099609 48.81009674072266 2.758136749267578 51.56827545166016 C 3.885158538818359 54.23286437988281 5.498805999755859 56.62611389160156 7.554256439208984 58.68155670166016 C 9.609706878662109 60.73699569702148 12.00296783447266 62.35064315795898 14.66755676269531 63.47767639160156 C 17.42574691772461 64.644287109375 20.35624694824219 65.23580169677734 23.37764739990234 65.23580169677734 C 26.3990478515625 65.23580169677734 29.32954788208008 64.644287109375 32.08773803710938 63.47767639160156 C 34.75232696533203 62.35064315795898 37.14558792114258 60.73699569702148 39.2010383605957 58.68155670166016 C 41.25648880004883 56.62611389160156 42.87013626098633 54.23286437988281 43.99715805053711 51.56827545166016 C 45.16377639770508 48.81009674072266 45.75529861450195 45.87960433959961 45.75529861450195 42.85821533203125 C 45.75529861450195 40.11753463745117 44.63458633422852 36.28740692138672 42.42428588867188 31.47423553466797 C 40.59249877929688 27.48530578613281 38.04119873046875 22.88381576538086 34.84126663208008 17.79758453369141 C 30.01606941223145 10.12803649902344 25.11821937561035 3.588119506835938 23.37764739990234 1.470855712890625 M 23.37764739990234 -7.62939453125e-06 C 23.89193725585938 -7.62939453125e-06 46.75529861450195 29.94712448120117 46.75529861450195 42.85821533203125 C 46.75529861450195 55.76929473876953 36.28876876831055 66.23580169677734 23.37764739990234 66.23580169677734 C 10.46652603149414 66.23580169677734 -3.814697265625e-06 55.76929473876953 -3.814697265625e-06 42.85821533203125 C -3.814697265625e-06 29.94712448120117 22.86335754394531 -7.62939453125e-06 23.37764739990234 -7.62939453125e-06 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -605.65, 396.58)"
                    filter="url(#Ellipse_2-8)"
                  >
                    <g
                      id="Ellipse_2-20"
                      data-name="Ellipse 2"
                      transform="translate(370.96 611.87) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-9"
                  data-name="Point Up"
                  transform="translate(812.671 0)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -930.47, 396.58)"
                    filter="url(#Path_337-9)"
                  >
                    <g
                      id="Path_337-21"
                      data-name="Path 337"
                      transform="translate(396.58 930.47) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.37764739990234 65.73581695556641 C 20.28896713256836 65.73581695556641 17.29293823242188 65.13100433349609 14.47278785705566 63.93818283081055 C 11.7485876083374 62.78594589233398 9.301907539367676 61.13632583618164 7.20070743560791 59.03511428833008 C 5.099497318267822 56.93391418457031 3.449867486953735 54.48724365234375 2.297627449035645 51.76305389404297 C 1.104807376861572 48.94291305541992 0.4999974071979523 45.94689559936523 0.4999974071979523 42.85821533203125 C 0.4999974071979523 39.25422286987305 2.425657510757446 31.90479469299316 11.59949779510498 17.35880470275879 C 16.75320243835449 9.187118530273438 22.05760383605957 2.211601257324219 23.37764739990234 0.6978706121444702 C 24.69769096374512 2.211601257324219 30.0020923614502 9.187118530273438 35.15579605102539 17.35880470275879 C 44.32963562011719 31.90479469299316 46.25529861450195 39.25422286987305 46.25529861450195 42.85821533203125 C 46.25529861450195 45.94689559936523 45.65048599243164 48.94291305541992 44.45766830444336 51.76305389404297 C 43.30542755126953 54.48724365234375 41.65579605102539 56.93391418457031 39.55458831787109 59.03511428833008 C 37.45338821411133 61.13632583618164 35.00670623779297 62.78594589233398 32.28250885009766 63.93818283081055 C 29.46235656738281 65.13100433349609 26.46632766723633 65.73581695556641 23.37764739990234 65.73581695556641 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.37764739990234 1.470855712890625 C 21.63707542419434 3.588119506835938 16.73922538757324 10.12803649902344 11.91402816772461 17.79758453369141 C 8.714096069335938 22.88381576538086 6.162796020507812 27.48530578613281 4.331008911132812 31.47423553466797 C 2.120708465576172 36.28740692138672 0.9999961853027344 40.11753463745117 0.9999961853027344 42.85821533203125 C 0.9999961853027344 45.87960433959961 1.591518402099609 48.81009674072266 2.758136749267578 51.56827545166016 C 3.885158538818359 54.23286437988281 5.498805999755859 56.62611389160156 7.554256439208984 58.68155670166016 C 9.609706878662109 60.73699569702148 12.00296783447266 62.35064315795898 14.66755676269531 63.47767639160156 C 17.42574691772461 64.644287109375 20.35624694824219 65.23580169677734 23.37764739990234 65.23580169677734 C 26.3990478515625 65.23580169677734 29.32954788208008 64.644287109375 32.08773803710938 63.47767639160156 C 34.75232696533203 62.35064315795898 37.14558792114258 60.73699569702148 39.2010383605957 58.68155670166016 C 41.25648880004883 56.62611389160156 42.87013626098633 54.23286437988281 43.99715805053711 51.56827545166016 C 45.16377639770508 48.81009674072266 45.75529861450195 45.87960433959961 45.75529861450195 42.85821533203125 C 45.75529861450195 40.11753463745117 44.63458633422852 36.28740692138672 42.42428588867188 31.47423553466797 C 40.59249877929688 27.48530578613281 38.04119873046875 22.88381576538086 34.84126663208008 17.79758453369141 C 30.01606941223145 10.12803649902344 25.11821937561035 3.588119506835938 23.37764739990234 1.470855712890625 M 23.37764739990234 -7.62939453125e-06 C 23.89193725585938 -7.62939453125e-06 46.75529861450195 29.94712448120117 46.75529861450195 42.85821533203125 C 46.75529861450195 55.76929473876953 36.28876876831055 66.23580169677734 23.37764739990234 66.23580169677734 C 10.46652603149414 66.23580169677734 -3.814697265625e-06 55.76929473876953 -3.814697265625e-06 42.85821533203125 C -3.814697265625e-06 29.94712448120117 22.86335754394531 -7.62939453125e-06 23.37764739990234 -7.62939453125e-06 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -930.47, 396.58)"
                    filter="url(#Ellipse_2-9)"
                  >
                    <g
                      id="Ellipse_2-21"
                      data-name="Ellipse 2"
                      transform="translate(370.96 936.68) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-10"
                  data-name="Point Up"
                  transform="translate(1137.484 0)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -1255.28, 396.58)"
                    filter="url(#Path_337-10)"
                  >
                    <g
                      id="Path_337-22"
                      data-name="Path 337"
                      transform="translate(396.58 1255.28) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.37764739990234 65.73581695556641 C 20.28896713256836 65.73581695556641 17.29293823242188 65.13100433349609 14.47278785705566 63.93818283081055 C 11.7485876083374 62.78594589233398 9.301907539367676 61.13632583618164 7.20070743560791 59.03511428833008 C 5.099497318267822 56.93391418457031 3.449867486953735 54.48724365234375 2.297627449035645 51.76305389404297 C 1.104807376861572 48.94291305541992 0.4999974071979523 45.94689559936523 0.4999974071979523 42.85821533203125 C 0.4999974071979523 39.25422286987305 2.425657510757446 31.90479469299316 11.59949779510498 17.35880470275879 C 16.75320243835449 9.187118530273438 22.05760383605957 2.211601257324219 23.37764739990234 0.6978706121444702 C 24.69769096374512 2.211601257324219 30.0020923614502 9.187118530273438 35.15579605102539 17.35880470275879 C 44.32963562011719 31.90479469299316 46.25529861450195 39.25422286987305 46.25529861450195 42.85821533203125 C 46.25529861450195 45.94689559936523 45.65048599243164 48.94291305541992 44.45766830444336 51.76305389404297 C 43.30542755126953 54.48724365234375 41.65579605102539 56.93391418457031 39.55458831787109 59.03511428833008 C 37.45338821411133 61.13632583618164 35.00670623779297 62.78594589233398 32.28250885009766 63.93818283081055 C 29.46235656738281 65.13100433349609 26.46632766723633 65.73581695556641 23.37764739990234 65.73581695556641 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.37764739990234 1.470855712890625 C 21.63707542419434 3.588119506835938 16.73922538757324 10.12803649902344 11.91402816772461 17.79758453369141 C 8.714096069335938 22.88381576538086 6.162796020507812 27.48530578613281 4.331008911132812 31.47423553466797 C 2.120708465576172 36.28740692138672 0.9999961853027344 40.11753463745117 0.9999961853027344 42.85821533203125 C 0.9999961853027344 45.87960433959961 1.591518402099609 48.81009674072266 2.758136749267578 51.56827545166016 C 3.885158538818359 54.23286437988281 5.498805999755859 56.62611389160156 7.554256439208984 58.68155670166016 C 9.609706878662109 60.73699569702148 12.00296783447266 62.35064315795898 14.66755676269531 63.47767639160156 C 17.42574691772461 64.644287109375 20.35624694824219 65.23580169677734 23.37764739990234 65.23580169677734 C 26.3990478515625 65.23580169677734 29.32954788208008 64.644287109375 32.08773803710938 63.47767639160156 C 34.75232696533203 62.35064315795898 37.14558792114258 60.73699569702148 39.2010383605957 58.68155670166016 C 41.25648880004883 56.62611389160156 42.87013626098633 54.23286437988281 43.99715805053711 51.56827545166016 C 45.16377639770508 48.81009674072266 45.75529861450195 45.87960433959961 45.75529861450195 42.85821533203125 C 45.75529861450195 40.11753463745117 44.63458633422852 36.28740692138672 42.42428588867188 31.47423553466797 C 40.59249877929688 27.48530578613281 38.04119873046875 22.88381576538086 34.84126663208008 17.79758453369141 C 30.01606941223145 10.12803649902344 25.11821937561035 3.588119506835938 23.37764739990234 1.470855712890625 M 23.37764739990234 -7.62939453125e-06 C 23.89193725585938 -7.62939453125e-06 46.75529861450195 29.94712448120117 46.75529861450195 42.85821533203125 C 46.75529861450195 55.76929473876953 36.28876876831055 66.23580169677734 23.37764739990234 66.23580169677734 C 10.46652603149414 66.23580169677734 -3.814697265625e-06 55.76929473876953 -3.814697265625e-06 42.85821533203125 C -3.814697265625e-06 29.94712448120117 22.86335754394531 -7.62939453125e-06 23.37764739990234 -7.62939453125e-06 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -1255.28, 396.58)"
                    filter="url(#Ellipse_2-10)"
                  >
                    <g
                      id="Ellipse_2-22"
                      data-name="Ellipse 2"
                      transform="translate(370.96 1261.49) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-11"
                  data-name="Point Up"
                  transform="translate(1788.148 0)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -1905.94, 396.58)"
                    filter="url(#Path_337-11)"
                  >
                    <g
                      id="Path_337-23"
                      data-name="Path 337"
                      transform="translate(396.58 1905.94) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.37764739990234 65.73581695556641 C 20.28896713256836 65.73581695556641 17.29293823242188 65.13100433349609 14.47278785705566 63.93818283081055 C 11.7485876083374 62.78594589233398 9.301907539367676 61.13632583618164 7.20070743560791 59.03511428833008 C 5.099497318267822 56.93391418457031 3.449867486953735 54.48724365234375 2.297627449035645 51.76305389404297 C 1.104807376861572 48.94291305541992 0.4999974071979523 45.94689559936523 0.4999974071979523 42.85821533203125 C 0.4999974071979523 39.25422286987305 2.425657510757446 31.90479469299316 11.59949779510498 17.35880470275879 C 16.75320243835449 9.187118530273438 22.05760383605957 2.211601257324219 23.37764739990234 0.6978706121444702 C 24.69769096374512 2.211601257324219 30.0020923614502 9.187118530273438 35.15579605102539 17.35880470275879 C 44.32963562011719 31.90479469299316 46.25529861450195 39.25422286987305 46.25529861450195 42.85821533203125 C 46.25529861450195 45.94689559936523 45.65048599243164 48.94291305541992 44.45766830444336 51.76305389404297 C 43.30542755126953 54.48724365234375 41.65579605102539 56.93391418457031 39.55458831787109 59.03511428833008 C 37.45338821411133 61.13632583618164 35.00670623779297 62.78594589233398 32.28250885009766 63.93818283081055 C 29.46235656738281 65.13100433349609 26.46632766723633 65.73581695556641 23.37764739990234 65.73581695556641 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.37764739990234 1.470855712890625 C 21.63707542419434 3.588119506835938 16.73922538757324 10.12803649902344 11.91402816772461 17.79758453369141 C 8.714096069335938 22.88381576538086 6.162796020507812 27.48530578613281 4.331008911132812 31.47423553466797 C 2.120708465576172 36.28740692138672 0.9999961853027344 40.11753463745117 0.9999961853027344 42.85821533203125 C 0.9999961853027344 45.87960433959961 1.591518402099609 48.81009674072266 2.758136749267578 51.56827545166016 C 3.885158538818359 54.23286437988281 5.498805999755859 56.62611389160156 7.554256439208984 58.68155670166016 C 9.609706878662109 60.73699569702148 12.00296783447266 62.35064315795898 14.66755676269531 63.47767639160156 C 17.42574691772461 64.644287109375 20.35624694824219 65.23580169677734 23.37764739990234 65.23580169677734 C 26.3990478515625 65.23580169677734 29.32954788208008 64.644287109375 32.08773803710938 63.47767639160156 C 34.75232696533203 62.35064315795898 37.14558792114258 60.73699569702148 39.2010383605957 58.68155670166016 C 41.25648880004883 56.62611389160156 42.87013626098633 54.23286437988281 43.99715805053711 51.56827545166016 C 45.16377639770508 48.81009674072266 45.75529861450195 45.87960433959961 45.75529861450195 42.85821533203125 C 45.75529861450195 40.11753463745117 44.63458633422852 36.28740692138672 42.42428588867188 31.47423553466797 C 40.59249877929688 27.48530578613281 38.04119873046875 22.88381576538086 34.84126663208008 17.79758453369141 C 30.01606941223145 10.12803649902344 25.11821937561035 3.588119506835938 23.37764739990234 1.470855712890625 M 23.37764739990234 -7.62939453125e-06 C 23.89193725585938 -7.62939453125e-06 46.75529861450195 29.94712448120117 46.75529861450195 42.85821533203125 C 46.75529861450195 55.76929473876953 36.28876876831055 66.23580169677734 23.37764739990234 66.23580169677734 C 10.46652603149414 66.23580169677734 -3.814697265625e-06 55.76929473876953 -3.814697265625e-06 42.85821533203125 C -3.814697265625e-06 29.94712448120117 22.86335754394531 -7.62939453125e-06 23.37764739990234 -7.62939453125e-06 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -1905.94, 396.58)"
                    filter="url(#Ellipse_2-11)"
                  >
                    <g
                      id="Ellipse_2-23"
                      data-name="Ellipse 2"
                      transform="translate(370.96 1912.16) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Point_Up-12"
                  data-name="Point Up"
                  transform="translate(1463.44 0)"
                >
                  <g
                    transform="matrix(0, -1, 1, 0, -1581.24, 396.58)"
                    filter="url(#Path_337-12)"
                  >
                    <g
                      id="Path_337-24"
                      data-name="Path 337"
                      transform="translate(396.58 1581.24) rotate(90)"
                      fill="#67bb4f"
                    >
                      <path
                        d="M 23.37764739990234 65.73581695556641 C 20.28896713256836 65.73581695556641 17.29293823242188 65.13100433349609 14.47278785705566 63.93818283081055 C 11.7485876083374 62.78594589233398 9.301907539367676 61.13632583618164 7.20070743560791 59.03511428833008 C 5.099497318267822 56.93391418457031 3.449867486953735 54.48724365234375 2.297627449035645 51.76305389404297 C 1.104807376861572 48.94291305541992 0.4999974071979523 45.94689559936523 0.4999974071979523 42.85821533203125 C 0.4999974071979523 39.25422286987305 2.425657510757446 31.90479469299316 11.59949779510498 17.35880470275879 C 16.75320243835449 9.187118530273438 22.05760383605957 2.211601257324219 23.37764739990234 0.6978706121444702 C 24.69769096374512 2.211601257324219 30.0020923614502 9.187118530273438 35.15579605102539 17.35880470275879 C 44.32963562011719 31.90479469299316 46.25529861450195 39.25422286987305 46.25529861450195 42.85821533203125 C 46.25529861450195 45.94689559936523 45.65048599243164 48.94291305541992 44.45766830444336 51.76305389404297 C 43.30542755126953 54.48724365234375 41.65579605102539 56.93391418457031 39.55458831787109 59.03511428833008 C 37.45338821411133 61.13632583618164 35.00670623779297 62.78594589233398 32.28250885009766 63.93818283081055 C 29.46235656738281 65.13100433349609 26.46632766723633 65.73581695556641 23.37764739990234 65.73581695556641 Z"
                        stroke="none"
                      />
                      <path
                        d="M 23.37764739990234 1.470855712890625 C 21.63707542419434 3.588119506835938 16.73922538757324 10.12803649902344 11.91402816772461 17.79758453369141 C 8.714096069335938 22.88381576538086 6.162796020507812 27.48530578613281 4.331008911132812 31.47423553466797 C 2.120708465576172 36.28740692138672 0.9999961853027344 40.11753463745117 0.9999961853027344 42.85821533203125 C 0.9999961853027344 45.87960433959961 1.591518402099609 48.81009674072266 2.758136749267578 51.56827545166016 C 3.885158538818359 54.23286437988281 5.498805999755859 56.62611389160156 7.554256439208984 58.68155670166016 C 9.609706878662109 60.73699569702148 12.00296783447266 62.35064315795898 14.66755676269531 63.47767639160156 C 17.42574691772461 64.644287109375 20.35624694824219 65.23580169677734 23.37764739990234 65.23580169677734 C 26.3990478515625 65.23580169677734 29.32954788208008 64.644287109375 32.08773803710938 63.47767639160156 C 34.75232696533203 62.35064315795898 37.14558792114258 60.73699569702148 39.2010383605957 58.68155670166016 C 41.25648880004883 56.62611389160156 42.87013626098633 54.23286437988281 43.99715805053711 51.56827545166016 C 45.16377639770508 48.81009674072266 45.75529861450195 45.87960433959961 45.75529861450195 42.85821533203125 C 45.75529861450195 40.11753463745117 44.63458633422852 36.28740692138672 42.42428588867188 31.47423553466797 C 40.59249877929688 27.48530578613281 38.04119873046875 22.88381576538086 34.84126663208008 17.79758453369141 C 30.01606941223145 10.12803649902344 25.11821937561035 3.588119506835938 23.37764739990234 1.470855712890625 M 23.37764739990234 -7.62939453125e-06 C 23.89193725585938 -7.62939453125e-06 46.75529861450195 29.94712448120117 46.75529861450195 42.85821533203125 C 46.75529861450195 55.76929473876953 36.28876876831055 66.23580169677734 23.37764739990234 66.23580169677734 C 10.46652603149414 66.23580169677734 -3.814697265625e-06 55.76929473876953 -3.814697265625e-06 42.85821533203125 C -3.814697265625e-06 29.94712448120117 22.86335754394531 -7.62939453125e-06 23.37764739990234 -7.62939453125e-06 Z"
                        stroke="none"
                        fill="#67bb4f"
                      />
                    </g>
                  </g>
                  <g
                    transform="matrix(0, -1, 1, 0, -1581.24, 396.58)"
                    filter="url(#Ellipse_2-12)"
                  >
                    <g
                      id="Ellipse_2-24"
                      data-name="Ellipse 2"
                      transform="translate(370.96 1587.45) rotate(90)"
                      fill="#fff"
                      stroke="#1c8000"
                      stroke-width="1"
                    >
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="17.044"
                        ry="17.044"
                        stroke="none"
                      />
                      <ellipse
                        cx="17.044"
                        cy="17.044"
                        rx="16.544"
                        ry="16.544"
                        fill="none"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <path
                id="Path_342"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 404.283)"
                fill="#fff"
              />
              <rect
                id="Rectangle_58"
                data-name="Rectangle 58"
                width="259.969"
                height="285.68"
                transform="translate(1095 404.283)"
                fill="#fff"
              />
              <path
                id="Path_342-2"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 727.283)"
                fill="#fff"
              />
              <rect
                id="Rectangle_58-2"
                data-name="Rectangle 58"
                width="259.969"
                height="285.68"
                transform="translate(1095 727.283)"
                fill="#fff"
              />
              <path
                id="Path_342-3"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 727.283)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="280"
                transform="translate(1095 727.283)"
                fill="url(#pattern3)"
                onClick={() =>
                  props.data[2].characters.length > 0
                    ? navigate(`/stories/${props.data[2].id}`)
                    : props.data[2].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[2].id}`)
                }
                style={{
                  cursor:
                    props.data[2].characters.length > 0
                      ? "pointer"
                      : props.data[2].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-4"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 1052.283)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-2"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1095 1052.283)"
                fill="url(#pattern5)"
                onClick={() =>
                  props.data[7].characters.length > 0
                    ? navigate(`/stories/${props.data[4].id}`)
                    : props.data[4].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[4].id}`)
                }
                style={{
                  cursor:
                    props.data[4].characters.length > 0
                      ? "pointer"
                      : props.data[4].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-5"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 1377.283)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-3"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1095 1377.283)"
                fill="url(#pattern7)"
                onClick={() =>
                  props.data[6].characters.length > 0
                    ? navigate(`/stories/${props.data[6].id}`)
                    : props.data[6].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[6].id}`)
                }
                style={{
                  cursor:
                    props.data[6].characters.length > 0
                      ? "pointer"
                      : props.data[6].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-6"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 1702.283)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-4"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1095 1702.283)"
                fill="url(#pattern9)"
                onClick={() =>
                  props.data[8].characters.length > 0
                    ? navigate(`/stories/${props.data[8].id}`)
                    : props.data[8].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[8].id}`)
                }
                style={{
                  cursor:
                    props.data[8].characters.length > 0
                      ? "pointer"
                      : props.data[8].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-7"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 2027.283)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-5"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1095 2027.283)"
                fill="url(#pattern11)"
                onClick={() =>
                  props.data[10].characters.length > 0
                    ? navigate(`/stories/${props.data[10].id}`)
                    : props.data[10].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[10].id}`)
                }
                style={{
                  cursor:
                    props.data[10].characters.length > 0
                      ? "pointer"
                      : props.data[10].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-8"
                data-name="Path 342"
                d="M257.112,99.988V0H0V285.68H257.112V185.692L285.68,142.84Z"
                transform="translate(1095 404.283)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-6"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1095 404.283)"
                fill="url(#pattern1)"
                onClick={() =>
                  props.data[0].characters.length > 0
                    ? navigate(`/stories/${props.data[0].id}`)
                    : props.data[0].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[0].id}`)
                }
                style={{
                  cursor:
                    props.data[0].characters.length > 0
                      ? "pointer"
                      : props.data[0].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-9"
                data-name="Path 342"
                d="M28.568,99.988V0H285.68V285.68H28.568V185.692L0,142.84Z"
                transform="translate(1513.488 566.154)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-7"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1539.199 566.154)"
                fill="url(#pattern2)"
                onClick={() =>
                  props.data[1].characters.length > 0
                    ? navigate(`/stories/${props.data[1].id}`)
                    : props.data[1].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[1].id}`)
                }
                style={{
                  cursor:
                    props.data[1].characters.length > 0
                      ? "pointer"
                      : props.data[1].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-10"
                data-name="Path 342"
                d="M28.568,99.988V0H285.68V285.68H28.568V185.692L0,142.84Z"
                transform="translate(1513.488 891.154)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-8"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1539.199 891.154)"
                fill="url(#pattern4)"
                onClick={() =>
                  props.data[3].characters.length > 0
                    ? navigate(`/stories/${props.data[3].id}`)
                    : props.data[3].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[3].id}`)
                }
                style={{
                  cursor:
                    props.data[3].characters.length > 0
                      ? "pointer"
                      : props.data[3].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-11"
                data-name="Path 342"
                d="M28.568,99.988V0H285.68V285.68H28.568V185.692L0,142.84Z"
                transform="translate(1513.488 1215.154)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-9"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1539.199 1215.154)"
                fill="url(#pattern6)"
                onClick={() =>
                  props.data[5].characters.length > 0
                    ? navigate(`/stories/${props.data[5].id}`)
                    : props.data[5].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[5].id}`)
                }
                style={{
                  cursor:
                    props.data[5].characters.length > 0
                      ? "pointer"
                      : props.data[5].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-12"
                data-name="Path 342"
                d="M28.568,99.988V0H285.68V285.68H28.568V185.692L0,142.84Z"
                transform="translate(1513.488 1539.154)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-10"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1539.199 1539.154)"
                fill="url(#pattern8)"
                onClick={() =>
                  props.data[7].characters.length > 0
                    ? navigate(`/stories/${props.data[7].id}`)
                    : props.data[7].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[7].id}`)
                }
                style={{
                  cursor:
                    props.data[7].characters.length > 0
                      ? "pointer"
                      : props.data[7].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-13"
                data-name="Path 342"
                d="M28.568,99.988V0H285.68V285.68H28.568V185.692L0,142.84Z"
                transform="translate(1513.488 1865.154)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-11"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1539.199 1865.154)"
                fill="url(#pattern10)"
                onClick={() =>
                  props.data[9].characters.length > 0
                    ? navigate(`/stories/${props.data[9].id}`)
                    : props.data[9].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[9].id}`)
                }
                style={{
                  cursor:
                    props.data[9].characters.length > 0
                      ? "pointer"
                      : props.data[9].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
              <path
                id="Path_342-14"
                data-name="Path 342"
                d="M28.568,99.988V0H285.68V285.68H28.568V185.692L0,142.84Z"
                transform="translate(1513.488 2191.154)"
                fill="#fff"
              />
              <rect
                id="Bloom_shifted_thumbnail-12"
                data-name="Bloom shifted thumbnail"
                width="259.969"
                height="285.68"
                transform="translate(1539.199 2191.154)"
                fill="url(#pattern12)"
                onClick={() =>
                  props.data[11].characters.length > 0
                    ? navigate(`/stories/${props.data[11].id}`)
                    : props.data[11].story_sets.length > 0 &&
                      navigate(`/stories/${props.data[11].id}`)
                }
                style={{
                  cursor:
                    props.data[11].characters.length > 0
                      ? "pointer"
                      : props.data[11].story_sets.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
              />
            </g>
          </g>
        </Svg>
      )}
    </>
  );
};

export default Icon;
